<template>
  <div class="section-card">
    <div v-if="immediateCharge" class="text-danger help-text">
      Your card will be charged straight away.
    </div>
    <div v-else class="help-text">
      Your card won't be charged until your order is ready to go out.
    </div>
    <integrapay-card-storage
      ref="cardForm"
      :input-config="integrapayConfig"
      :callback="processCreditCard"
      @valid-card="validCard"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import fingerprint from '../fingerprint'

export default {
  name: 'card-display-integrapay-add-card',
  data: function() {
    return {
      cardReadyToSubmit: false
    }
  },
  computed: {
    ...mapState('somnambulistui', ['payer', 'payerValid', 'orderOneNow', 'orderId']),
    ...mapMutations('somnambulistui', ['SET_PAYER', 'SET_PAYER_VALID']),
    ...mapGetters('somnambulistui', ['getSelectedQuantityObject']),
    immediateCharge() {
      return !this.orderId && this.getSelectedQuantityObject.allowOrderNow && this.orderOneNow
    },
    integrapayConfig() {
      return {
        uri: this.$store.getters['getServiceEndpoint']('datastore'),
        siteID: this.$store.getters['getSiteId'],
        showErrors: false,
        paymentTesting: this.$store.getters['ecommerce/getConfigItem']('integrapay', 'testmode'),
        showSaveButton: true,
        useStoredCreditCards: false,
        cardSave: false,
        buttonLabel: 'Store Card Details',
        errorHandling: 'internal',
        internalSuccessMessage: false,
        internalFailureMessage: false,
        recaptcha: null
      }
    }
  },
  methods: {
    processCreditCard: function(_component, token) {
      fingerprint()
        .then(fingerprint => {
          return this.$store.getters['somnambulistui/graphQLClient']
            .onQuery(context => {
              context['headers']['X-Client-ID'] = fingerprint
              return context
            })
            .mutate({ opName: 'StoreCreditCard', variables: { token: token } })
        })
        .then(response => {
          if (response.errors) {
            let messages = response.errors.map(({ debugMessage }) => debugMessage)
            this.$emit('error', new Error(messages.join('::')))
          }
          else {
            this.$emit('selected-card', { provider: 'integrapay', ...response.data.card })
          }
        })
    },
    clearCard(val) {
      this.SET_PAYER_VALID(val)
    },
    validCard(val) {
      this.cardReadyToSubmit = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-title {
    margin: 0 0 2em 0;
    width: 100%;
    text-align: center;
  }
  .help-text {
    text-align: center;
    padding-bottom: 2em;
    border-bottom: 1px solid var(--main-border-color);
    margin-bottom: 2em;
  }
</style>
